import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { AppDataContext } from '../../../context/Context';
import i18n from '../../../i18n';
import { Autocomplete, TextField, FormControl } from '@mui/material';
import { getExtractValue } from '../../../utils/formatName';

class FilterContextField extends Component {
    static contextType = AppDataContext;

    constructor(props) {
        super(props);
        this.state = { items: [] };
        this.unsubscribe = () => {};
    }

    componentDidMount() {
        this.unsubscribe = this.context.subscribe(this.fetchData);
        this.fetchData();
    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    fetchData = () => {
        const { controllersData } = this.context.getState();
        const filterByKey = this.props.field.filterBy;

        if (controllersData?.[filterByKey]) {
            this.setState({ items: controllersData[filterByKey] });
        } else {
            console.warn(`controllersData missing key: ${filterByKey}`);
            this.setState({ items: [] });
        }
    };

    getSelectedItem = () => {
        const { field } = this.props;
        const filterField = field.filterField || field.id;
        const fieldKey = this.getFullFieldKey(filterField);
        const match = this.props.filters
            .flat()
            ?.find((f) => f.field === fieldKey);
        const id = match?.value?.[0];

        const item = this.state.items.find((it) => it.id === id) || null;

        const { show, nestedFilterObject, secondaryFilterObject } = this.props.field;
        const name = item ? getExtractValue(item, show, nestedFilterObject, secondaryFilterObject) : '';
        return item ? { id: item.id, name: name } : null;
    };

    handleChange = (_, newValue) => {
        const filterField = this.props.field.filterField || this.props.field.id;
        const fieldKey = this.getFullFieldKey(filterField);
        this.props.handleFilter(fieldKey, newValue ? [newValue.id] : []);
    };

    getFullFieldKey = (field) => {
        return field.endsWith('Id')
            ? field.slice(0, -2) + '.id'
            : field + '.id';
    };

    getTranslatedLabel = () => {
        const label = this.props.field.label;
        return i18n.t('text.filterBy', {
            field: i18n.t(`columns.${label}`)
        });
    };

    render() {
        const { field } = this.props;
        const { show, nestedFilterObject, secondaryFilterObject } = field;
        const { items } = this.state;
        const isNeedTranslate = !!field.translate;
        const translateKey = field.translate || 'enums';
        let selectedItem = this.getSelectedItem();
        const formattedItems = items.map((item) => {
            const name = getExtractValue(item, show, nestedFilterObject, secondaryFilterObject);
            return { id: item.id, name: name };
        });
        return (
            <FormControl
                sx={{
                    width: '100%',
                    flex: '1 1 0',
                    minWidth: '100px',
                    maxWidth: this.props.maxWidth
                        ? this.props.maxWidth
                        : '350px',
                    m: 1
                }}
                title={
                    this.props.disabled
                        ? 'Disabled'
                        : undefined
                }
            >
                <Autocomplete
                    disabled={this.props.disabled}
                    value={selectedItem}
                    onChange={this.handleChange}
                    options={formattedItems}
                    getOptionLabel={(option) =>
                        isNeedTranslate
                            ? i18n.t(`${translateKey}.${option.name}`)
                            : option.name
                    }
                    renderOption={(props, option) => {
                        const baseName = option.name || '';
                        const label = isNeedTranslate
                            ? i18n.t(`${translateKey}.${baseName}`)
                            : baseName;

                        return (
                            <li {...props} key={option.id}>
                                {label}
                            </li>
                        );
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={this.getTranslatedLabel()}
                            helperText={this.props.helperText}
                            variant="outlined"
                            sx={{
                                maxWidth: this.props.maxWidth
                            }}
                        />
                    )}
                    isOptionEqualToValue={(opt, val) => opt.id === val.id}
                    sx={{
                        '& .MuiInputBase-root': {
                            cursor: this.props.disabled && 'text',
                            backgroundColor: this.props.disabled
                                ? '#fafafa'
                                : 'inherit'
                        },
                        "maxWidth": this.props.maxWidth
                    }}
                />
            </FormControl>
        );
    }
}

FilterContextField.propTypes = {
    field: PropTypes.object.isRequired,
    handleFilter: PropTypes.func.isRequired,
    filters: PropTypes.array
};

export default FilterContextField;
